import { createSelector } from "@ngrx/store";
import { IAppBooted } from "../../models/boot";
import { IAppState } from "../states/app";

export const selectAppBootState = createSelector(
  (state: IAppState) => state.booted,
  (state: IAppBooted) => state,
);
